import { StyleSheet } from 'react-native';
import Typography from '../../../../shared/constants/Typography';
import Colors from '../../../../shared/theme/colors';

export const signatureModalStyles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.4)',
    justifyContent: Typography.textAlign.centerAlign,
    alignItems: Typography.textAlign.centerAlign,
  },
  modalContainer: {
    backgroundColor: Colors.white,
    borderRadius: Typography.radius.radius8,
    padding: Typography.padding.padding16,
  },
  close: {
    position: Typography.position.absolute,
    top: Typography.gap.gap10,
    right: Typography.gap.gap10,
    zIndex: 10,
  },
  closeText: {
    fontSize: Typography.fontSize.fontSize20,
  },
  label: {
    textAlign: Typography.textAlign.centerAlign,
    marginBottom: Typography.margin.margin10,
    fontWeight: Typography.fontWeight.medium,
  },
  actions: {
    flexDirection: 'row',
    justifyContent: Typography.contentAlign.spaceBetween,
    marginTop: Typography.margin.margin12,
  },
  errorText: {
    color: 'red',
    textAlign: Typography.textAlign.centerAlign,
    marginTop: Typography.margin.margin8,
  },
  canvasContainer: { flex: 1 },
  canvas: {
    flex: 1,
    borderWidth: Typography.borderWidth.borderWidth1,
    borderColor: Colors.lightGrey,
  },
  msg: {
    textAlign: Typography.textAlign.centerAlign,
    marginBottom: Typography.margin.margin10,
    color: Colors.green,
  },
  errorMsg: {
    textAlign: Typography.textAlign.centerAlign,
    marginBottom: Typography.margin.margin10,
    color: Colors.red,
  },
  row: {
    flexDirection: 'row',
    justifyContent: Typography.contentAlign.spaceBetween,
  },
  btn: {
    flex: 1,
    margin: Typography.margin.margin4,
    padding: Typography.padding.padding14,
    backgroundColor: Colors.black,
    borderRadius: Typography.radius.radius4,
  },
  disabled: { backgroundColor: Colors.darkGrey },
  btnText: { color: Colors.white, textAlign: Typography.textAlign.centerAlign },
});
